import {
    Box,
    Button,
    Card,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    IconButton,
} from '@mui/material'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/system'
import { useCallback, useEffect, useState } from 'react'
import CustomTable from '../../components/CustomTable/CustomTable'
import columnsData from '../../util/tableColumn'
import { useCustomAxios } from '../../axiosInstance'
import moment from 'moment'
import { teal } from '@mui/material/colors'
import { FileUploader } from 'react-drag-drop-files'
import LoadingButton from '@mui/lab/LoadingButton'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import GetAppIcon from '@mui/icons-material/GetApp'
import {
    downloadFile,
    saveByteArray,
    uploadFile,
} from '../../util/uploadLetter'
import { toastError, toastSuccess } from '../../util/toastUtil'
import Modal from '@mui/material/Modal'
import { Document, Page, pdfjs } from 'react-pdf'
import { useNavigate } from 'react-router-dom'
import './dashboard.css'
import PictureAsPdf from '@mui/icons-material/PictureAsPdf'
import CloseIcon from '@mui/icons-material/Close'
import { HOME_ENDPOINTS } from '../../constants/apiConstants'
import {
    BASE_ROUTE_ENDPOINTS,
    NAVIGATION_LINKS,
} from '../../constants/routeConstants'

const debounce = (func, delay) => {
    let timeout
    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(this, args), delay)
    }
}

const StyledButton = styled(Button)(({ bgcolor, hovercolor }) => ({
    color: '#fff',
    backgroundColor: bgcolor || '#757575',
    '&:hover': {
        backgroundColor: hovercolor || '#616161',
    },
    padding: '6px 16px',
    fontSize: '0.875rem',
}))

const Dashboard = ({ setLoadingDataGlobal }) => {
    const axios = useCustomAxios()
    const navigate = useNavigate()
    const [filterList, setFilterList] = useState(null)
    const [year, setYear] = useState('')
    const [reqStatus, setReqStatus] = useState('')
    const [applicant, setApplicant] = useState('')
    const [showUploadBox, setShowUploadbox] = useState(false)
    const [userRowData, setUserRowData] = useState(null)
    const [uploadChecked, setUploadChecked] = useState(false)
    const [pdfFile, setPdfFile] = useState(null)
    const [loadingUpload, setLoadingUpload] = useState(false)
    const [pdfDoc, setPdfDoc] = useState(null)
    const [tableHeight, setTableHeight] = useState(0)

    const [tableData, setTableData] = useState([])
    const [open, setOpen] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)
    const [confirmMessage, setConfirmMessage] = useState('')
    const [confirmType, setConfirmType] = useState(0)
    const [confirmTitle, setConfirmTitle] = useState('')

    const [uploadStatus, setUploadStatus] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const handleOpenConfirm = () => setOpenConfirm(true)
    const handleCloseConfirm = () => setOpenConfirm(false)

    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)
    const [pageWidth, setPageWidth] = useState(window.innerWidth * 0.7)

    const currentYear = moment().year()

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages)
        setPageNumber(1)
    }

    const tableHeightSet = (data) => {
        if (data.length < 10) {
            let height = 74 * data.length + 153
            setTableHeight(height)
        } else {
            let height = 74 * 10 + 153
            setTableHeight(height)
        }
    }

    const updatePageWidth = useCallback(
        debounce(() => {
            setPageWidth(window.innerWidth * 0.7)
        }, 100), // Debounce delay of 100ms
        []
    )

    useEffect(() => {
        updatePageWidth() // Initialize page width
        window.addEventListener('resize', updatePageWidth) // Add event listener to update page width on window resize

        return () => {
            window.removeEventListener('resize', updatePageWidth) // Clean up event listener on component unmount
        }
    }, [updatePageWidth])

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
        let isSubscribed = true
        window.scrollTo(0, 0)

        const user = sessionStorage.getItem('user')
        let userData = JSON.parse(user)
        if (!userData.hasProfile) {
            navigate(NAVIGATION_LINKS.UPDATEPROFILE, {
                replace: true,
            })
        }
        // sessionStorage.setItem('user', JSON.stringify(user))

        const fetchData = async () => {
            const data = await getSearchFilterData()
            if (isSubscribed) {
                setFilterList(data)
                setYear(data.years[0].entryYearId)
                handleSearchLetters(data.years[0].entryYearId)
            }
        }

        // call the function
        fetchData()

        return () => (isSubscribed = false)
    }, [])

    const getSearchFilterData = async () => {
        setLoadingDataGlobal(true)
        return axios
            .get(HOME_ENDPOINTS.GETDLLS)
            .then((response) => {
                return response.data
            })
            .catch((err) => {
                // console.log(err);
                setLoadingDataGlobal(false)
                toastError(
                    "Couldn't fetch data. Please refresh the page and try again."
                )
            })
    }

    const handleCloseUploadModal = () => {
        setShowUploadbox(false)
        // Reset related states if necessary
        setUploadChecked(false)
        setPdfFile(null)
        setUploadStatus(null)
        setErrorMessage(null)
    }

    const deleteDocument = async (params) => {
        const config = {
            params: {
                letterId: params.id,
            },
        }
        const data = await axios
            .delete(HOME_ENDPOINTS.DELETELETTER, config)
            .then((response) => {
                return true
            })
            .catch((err) => {
                // console.log(err);
                setLoadingDataGlobal(false)
                return false
            })

        return data
    }

    const checkReviewStatus = (rowData) => {
        if (
            rowData.documentStatus == 'Received/Approved' ||
            moment(rowData.createdDate).year() < currentYear - 1
        ) {
            return true
        }
        return false
    }

    const onClickActionButton = async (params) => {
        if (
            params.collegeType !== 'Veterinary' &&
            !params.isUploaded &&
            params.letterRequestMethodId !== 7
        ) {
            setUserRowData(params)
            setShowUploadbox(true)
        } else if (params.collegeType === 'Veterinary') {
            navigate(`${NAVIGATION_LINKS.VETEVALFORM}/${params.id}`)
        } else if (params.letterRequestMethodId === 7) {
            navigate(`${NAVIGATION_LINKS.EVALLETTERFORM}/${params.id}`)
        } else {
            handleOpenConfirm()
            setConfirmTitle('Delete PDF')
            setConfirmMessage('Are you sure, you want to delete?')
            setConfirmType(1)
            setUserRowData(params)
        }
    }

    const confirmDeleteDoc = async () => {
        setLoadingDataGlobal(true)
        const deleteData = await deleteDocument(userRowData)
        if (deleteData) {
            setTimeout(async () => {
                toastSuccess('Document deleted successfully')
                handleCloseConfirm()
                setYear(filterList.years[0].entryYearId)
                handleSearchLetters(filterList.years[0].entryYearId)
            }, 1000)
        } else {
            toastError('Something went wrong! Please try again.')
        }
    }

    const onClickDeclineButton = async () => {
        setLoadingDataGlobal(true)
        axios
            .post(`${HOME_ENDPOINTS.DECLINED}${userRowData.id}`)
            .then((response) => {
                setTimeout(async () => {
                    setLoadingDataGlobal(false)
                    handleCloseConfirm()
                    toastSuccess(
                        `Request for ${userRowData.applicantFullName} declined`
                    )
                    setYear(filterList.years[0].entryYearId)
                    handleSearchLetters(filterList.years[0].entryYearId)
                }, 1000)
            })
            .catch((err) => {
                setLoadingDataGlobal(false)
                toastError(
                    "Couldn't decline the request. Please refresh the page and try again."
                )
            })
    }

    const handleConfirmSubmit = () => {
        if (confirmType == 1) {
            confirmDeleteDoc()
        } else {
            onClickDeclineButton()
        }
    }

    const onTypeError = (err) => {
        setPdfFile(null)
        setErrorMessage(
            <div>
                {err} <br /> Only PDF files can be uploaded
            </div>
        )
        setUploadStatus(null)
    }

    const onSizeError = (err) => {
        setPdfFile(null)
        setErrorMessage(
            <div>
                File size exceeds max limit of 6 MB. <br /> Please upload a
                smaller file.
            </div>
        )
        setUploadStatus(null)
    }

    const renderActionButton = (params) => {
        // console.log(params.row)
        if (
            params.row.collegeType != 'Veterinary' &&
            params.row.letterRequestMethodId !== 7
        ) {
            return (
                <strong>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={checkReviewStatus(params.row)}
                        style={{
                            marginLeft: 'auto',
                            backgroundColor: params.row.isUploaded
                                ? '#EA5755'
                                : '#4fb1aa',
                        }}
                        onClick={() => onClickActionButton(params.row)}>
                        {params.row.isUploaded ? 'Delete' : 'Upload'}
                    </Button>
                </strong>
            )
        }
        if (!params.row.isUploaded) {
            return (
                <strong>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={checkReviewStatus(params.row)}
                        style={{ marginLeft: 'auto' }}
                        onClick={() => onClickActionButton(params.row)}>
                        {params.row.letterRequestStatusId === 4
                            ? 'Edit'
                            : 'Start'}
                    </Button>
                </strong>
            )
        } else return <></>
    }

    const renderDeclineButton = (params) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    size="small"
                    style={{ marginLeft: 'auto', backgroundColor: '#EA5755' }}
                    disabled={checkReviewStatus(params.row)}
                    onClick={() => {
                        handleOpenConfirm()
                        setConfirmTitle('Decline Recommendation')
                        setConfirmMessage(
                            'Are you sure, you want to decline this applicant?'
                        )
                        setConfirmType(2)
                        setUserRowData(params.row)
                    }}>
                    Decline
                </Button>
            </strong>
        )
    }

    const renderViewButton = (params) => {
        if (params.row.isUploaded) {
            return (
                <strong>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginLeft: 'auto' }}
                        onClick={async () => {
                            if (params.row.collegeType != 'Veterinary') {
                                const data = await downloadFile(
                                    axios,
                                    params.row.id,
                                    setLoadingDataGlobal
                                )
                                if (data) {
                                    handleOpen()
                                    setPdfDoc({
                                        name: data.name,
                                        data: data.data,
                                    })
                                } else {
                                    toastError(
                                        'Something went wrong! Please try again.'
                                    )
                                }
                            } else {
                                navigate(
                                    `${NAVIGATION_LINKS.VETEVALFORM}/${params.id}`
                                )
                            }
                        }}>
                        View
                    </Button>
                </strong>
            )
        } else {
            return null
        }
    }

    const renderLoadingPage = () => {
        return (
            <div className="loading-progress-container">
                <CircularProgress size={50} color="success" />
            </div>
        )
    }

    const addIndexToData = (data) => {
        return data.map((item, index) => ({
            ...item,
            index: index + 1, // Adding 1 to start the index from 1
        }))
    }

    const handleSearchLetters = async (selectedYear) => {
        const params = {
            entryYearId: selectedYear != 'All' ? selectedYear : '',
            applicantUserId: applicant != 'All' ? applicant : '',
            statusId: reqStatus != 'All' ? reqStatus : '',
        }
        const config = {
            params,
        }

        const data = await axios
            .get(HOME_ENDPOINTS.GETLETTERS, config)
            .then((response) => {
                return response.data
            })
            .catch((err) => {
                // console.log(err);
            })

        if (data) {
            const indexedData = addIndexToData(data)
            setTableData(indexedData)
            tableHeightSet(data)
            setLoadingDataGlobal(false)
        }
    }

    const handlePdfChange = (file) => {
        setPdfFile(file)
        setUploadStatus('File uploaded successfully')
    }

    const uploadPdf = async () => {
        if (!pdfFile) {
            toastError('Please upload a PDF file first!')
            return
        }
        const fileData = {
            file: pdfFile[0],
            appId: userRowData.appId,
            letterId: userRowData.id,
        }

        // setLoadingDataGlobal(true)
        setLoadingDataGlobal(true)

        uploadFile(axios, fileData)
            .then((uploadData) => {
                toastSuccess('File Uploaded Successfully!')
                setShowUploadbox(false)
                setUploadChecked(false)
                setYear(filterList.years[0].entryYearId)
                handleSearchLetters(filterList.years[0].entryYearId)
            })
            .catch((error) => {
                toastError('Something went wrong! Please try again.')
            })
            .finally(() => {
                setLoadingDataGlobal(false)
            })
    }

    return (
        <>
            <Dialog
                open={openConfirm}
                onClose={handleCloseConfirm}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {confirmTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {confirmMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirm} color="primary">
                        No
                    </Button>
                    <StyledButton
                        bgcolor={'#4fb1aa'}
                        hovercolor={'#fc493d'}
                        onClick={handleConfirmSubmit}
                        autoFocus>
                        Yes
                    </StyledButton>
                </DialogActions>
            </Dialog>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="modal"
                onClick={handleClose} // Close modal on clicking outside
            >
                <div
                    onClick={(event) => event.stopPropagation()} // Prevent event propagation to modal
                    className="modal-inner-container">
                    <div className="modal-inner-container-header">
                        <IconButton
                            onClick={handleClose}
                            style={{ color: 'grey' }}>
                            <CloseIcon style={{ fontSize: 30 }} />
                        </IconButton>
                        <IconButton
                            onClick={async () => {
                                saveByteArray(pdfDoc.name, pdfDoc.data)
                            }}
                            style={{ color: 'grey' }}>
                            <GetAppIcon style={{ fontSize: 30 }} />
                        </IconButton>
                    </div>
                    <div className="pdf-container">
                        <Document
                            loading={renderLoadingPage}
                            file={pdfDoc}
                            onLoadSuccess={onDocumentLoadSuccess}>
                            {Array.from(new Array(numPages), (el, index) => (
                                <div
                                    key={`page_${index + 1}`}
                                    className="pdf-page">
                                    <Page
                                        loading={renderLoadingPage}
                                        pageNumber={index + 1}
                                        width={pageWidth} // Set the responsive width of each page
                                    />
                                </div>
                            ))}
                        </Document>
                    </div>
                </div>
            </Modal>
            <Box
                sx={{
                    padding: '20px 10px',
                }}>
                <Typography variant="h5">Evaluator Portal</Typography>
                <Divider />
            </Box>
            <Box className="dashboard-main-content-container">
                <Typography variant="h6">
                    Letters of Evaluation Requests
                </Typography>
                <Divider sx={{ marginBottom: '20px' }} />
                <div>
                    <Typography sx={{ padding: '5px 0px', minWidth: '100%' }}>
                        Below is a list of applicants requesting for your letter
                        of evaluation to be uploaded into the system on their
                        behalf. Click the Upload button to begin uploading your
                        document, or the Decline button to decline the
                        applicant's request.
                    </Typography>
                    <Typography sx={{ padding: '5px 0px', minWidth: '100%' }}>
                        Evaluators completing a Veterinary Evaluation Form will
                        not upload the evaluation but complete the form on-line.
                        (see instructions below)
                    </Typography>
                    <Typography sx={{ padding: '5px 0px', minWidth: '100%' }}>
                        Please note it takes 7-10 business days to process
                        letters of evaluation after they have been received.
                    </Typography>
                    <Typography
                        sx={{
                            padding: '5px 0px',
                            fontWeight: 'bold',
                            minWidth: '100%',
                        }}>
                        Filter the result set by selecting the following options
                        and then click the Search button.
                    </Typography>
                </div>
                <div
                    style={{
                        padding: 4,
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <div
                        style={{
                            padding: 0,
                            display: 'flex',
                            flex: 1,
                            alignItems: 'center',
                        }}>
                        <FormControl
                            size="small"
                            sx={{ width: 125, margin: '5px 5px' }}>
                            <InputLabel id="entry-year-label">
                                Entry Year
                            </InputLabel>
                            <Select
                                labelId="entry-year-label"
                                id="entry-year-select"
                                value={year}
                                label="Entry Year"
                                onChange={(e) => setYear(e.target.value)}>
                                <MenuItem value="All">
                                    <em>All</em>
                                </MenuItem>
                                {filterList
                                    ? filterList.years.map((item) => {
                                          return (
                                              <MenuItem
                                                  key={item.entryYearId}
                                                  value={item.entryYearId}>
                                                  {item.entryYearDescr}
                                              </MenuItem>
                                          )
                                      })
                                    : null}
                            </Select>
                        </FormControl>
                        <FormControl
                            size="small"
                            sx={{ width: 160, margin: '5px 5px' }}>
                            <InputLabel id="req-status-select-label">
                                Request Status
                            </InputLabel>
                            <Select
                                labelId="req-status-select-label"
                                id="req-status-select"
                                value={reqStatus}
                                label="Request Status"
                                onChange={(e) => setReqStatus(e.target.value)}>
                                <MenuItem value="All">
                                    <em>All</em>
                                </MenuItem>
                                {filterList
                                    ? filterList.statusList.map((item) => {
                                          return (
                                              <MenuItem
                                                  key={
                                                      item.letterRequestStatusId
                                                  }
                                                  value={
                                                      item.letterRequestStatusId
                                                  }>
                                                  {item.letterRequestStatusDesc}
                                              </MenuItem>
                                          )
                                      })
                                    : null}
                            </Select>
                        </FormControl>
                        <FormControl
                            size="small"
                            sx={{ width: 115, margin: '5px 5px' }}>
                            <InputLabel id="applicant-name-select-label">
                                Applicant
                            </InputLabel>
                            <Select
                                labelId="applicant-name-select-label"
                                id="applicant-name-select"
                                value={applicant}
                                label="Applicant"
                                onChange={(e) => setApplicant(e.target.value)}>
                                <MenuItem value="All">
                                    <em>All</em>
                                </MenuItem>
                                {filterList
                                    ? filterList.applicants.map((item) => {
                                          return (
                                              <MenuItem
                                                  key={item.userId}
                                                  value={item.userId}>
                                                  {item.userName}
                                              </MenuItem>
                                          )
                                      })
                                    : null}
                            </Select>
                        </FormControl>
                        <Button
                            onClick={() => handleSearchLetters(year)}
                            sx={{ height: 40, marginLeft: '5px' }}
                            size="small"
                            variant="contained">
                            Search
                        </Button>
                    </div>
                    <CustomTable
                        rows={tableData}
                        columns={columnsData.evalreqList(
                            renderActionButton,
                            renderDeclineButton,
                            renderViewButton
                        )}
                        pageSize={50}
                        rowHeight={70}
                        height={tableHeight}
                        rowsPerPageOptions={[50]}
                    />
                </div>

                <Modal
                    open={showUploadBox}
                    onClose={handleCloseUploadModal}
                    aria-labelledby="upload-modal-title"
                    aria-describedby="upload-modal-description"
                    style={{ overflowY: 'auto' }}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: {
                                xs: '90%',
                                sm: '80%',
                                md: '70%',
                                lg: '60%',
                                xl: '50%',
                            },
                            maxWidth: '700px',
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 4,
                            overflowY: 'auto',
                            maxHeight: '90vh',
                        }}>
                        <div>
                            <Typography
                                id="upload-modal-title"
                                variant="h6"
                                component="h2">
                                Upload Letter for{' '}
                                {userRowData?.applicantFullName}
                            </Typography>
                            <Typography sx={{ fontSize: 14 }}>
                                I understand that by checking this box and
                                successfully uploading the evaluation that I am
                                providing my electronic signature to certify
                                that I have uploaded an evaluation on the
                                applicant's behalf.
                            </Typography>
                            <Checkbox
                                sx={{
                                    color: teal[800],
                                    '&.Mui-checked': {
                                        color: teal[600],
                                    },
                                }}
                                onClick={() => {
                                    setUploadChecked(!uploadChecked)
                                    setPdfFile(null)
                                    setUploadStatus(null)
                                    setErrorMessage(null)
                                }}
                            />
                            <Button
                                variant="contained"
                                // color="primary"
                                size="small"
                                sx={{
                                    marginLeft: '10px',
                                    bgcolor: '#F53649',
                                    ':hover': {
                                        bgcolor: '#a61f2d',
                                    },
                                }}
                                onClick={handleCloseUploadModal}>
                                Cancel
                            </Button>
                        </div>
                        {uploadChecked ? (
                            <div>
                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 'bold',
                                    }}>
                                    Electronically signed by{' '}
                                    {userRowData.evaluatorName} on:{' '}
                                    {moment(new Date()).format(
                                        'MM-DD-YYYY hh:mm a'
                                    )}
                                </Typography>
                                <div style={{ margin: '10px' }}>
                                    <FileUploader
                                        multiple={true}
                                        handleChange={handlePdfChange}
                                        name="file"
                                        types={['pdf']}
                                        classes={'upload-box'}
                                        onTypeError={(err) => {
                                            onTypeError(err)
                                        }}
                                        onSizeError={(file) => {
                                            onSizeError(file)
                                        }}
                                        minSize={0}
                                        maxSize={6}
                                        children={
                                            <div
                                                style={{
                                                    padding: '20px',
                                                    textAlign: 'center',
                                                    border: '2px dashed #000',
                                                    borderRadius: '4px',
                                                    borderColor: '#1976D2',
                                                    margin: '10px',
                                                    cursor: 'pointer',
                                                }}>
                                                {uploadStatus ? (
                                                    <p>{uploadStatus}</p>
                                                ) : errorMessage ? (
                                                    <p
                                                        style={{
                                                            color: 'red',
                                                        }}>
                                                        {errorMessage}
                                                    </p>
                                                ) : (
                                                    <>
                                                        <PictureAsPdf
                                                            style={{
                                                                fontSize: 40,
                                                                color: '#1976D2',
                                                            }}
                                                        />
                                                        <p
                                                            style={{
                                                                fontSize:
                                                                    '20px',
                                                            }}>
                                                            {' '}
                                                            Drag & Drop your PDF
                                                            here or click
                                                            anywhere to Upload
                                                        </p>
                                                        <p
                                                            style={{
                                                                fontSize:
                                                                    '14px',
                                                            }}>
                                                            Only .PDF files can
                                                            be uploaded. Having
                                                            difficulty? Call us
                                                            at (512) 499-4785 or
                                                            email:
                                                            info@tmdsas.com
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        }
                                    />
                                </div>

                                <div>
                                    <Typography>
                                        {pdfFile
                                            ? `File name: ${pdfFile[0].name}`
                                            : 'no files uploaded yet'}
                                    </Typography>
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <LoadingButton
                                        onClick={uploadPdf}
                                        endIcon={<UploadFileIcon />}
                                        loading={loadingUpload}
                                        loadingPosition="end"
                                        variant="contained">
                                        Upload
                                    </LoadingButton>
                                </div>
                            </div>
                        ) : null}
                    </Box>
                </Modal>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                    }}>
                    <div>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" component="div">
                                    Don't see the Letter of Evaluation Requests?
                                </Typography>
                                <Typography
                                    sx={{ fontSize: 14, fontWeight: 'bold' }}
                                    color="text.primary"
                                    gutterBottom>
                                    Two potential Issues:
                                </Typography>
                                <Typography variant="body2">
                                    <ol>
                                        <li>
                                            The applicant has withdrawn their
                                            request.
                                        </li>
                                        <li>
                                            Ensure you log in with the email
                                            where you received the link.
                                        </li>
                                    </ol>
                                </Typography>
                                <Typography variant="h6" component="div">
                                    For dental and medical letter of evaluation
                                    instructions, please review our evaluator
                                    support page:
                                </Typography>
                                <Typography variant="body2">
                                    <a
                                        onClick={() =>
                                            window.open(
                                                'http://www.tmdsas.com/SUPPORT/evaluators.html',
                                                '_blank'
                                            )
                                        }
                                        style={{ cursor: 'pointer' }}>
                                        <Typography sx={{ color: 'blue' }}>
                                            Evaluator Support
                                        </Typography>
                                    </a>
                                </Typography>
                            </CardContent>
                        </Card>
                        <br></br>
                        <Card>
                            <CardContent>
                                <Typography
                                    variant="h5"
                                    component="div"
                                    sx={{
                                        display: 'inline',
                                        color: 'maroon',
                                    }}>
                                    VETERINARY EVALUATION FORM INSTRUCTIONS
                                </Typography>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.primary"
                                    gutterBottom>
                                    <ol
                                        style={{
                                            margin: 0,
                                            lineHeight: '18px',
                                        }}>
                                        <li>
                                            Select "start" to complete the
                                            Veterinary Evaluation Form.
                                        </li>
                                        <li>
                                            After all questions are completed,
                                            click the submit button. If you need
                                            to save your work, click the save
                                            button and submit later.
                                        </li>
                                    </ol>
                                </Typography>
                                <Typography variant="h6" component="div">
                                    FAQ
                                </Typography>
                                <Typography
                                    sx={{ fontSize: 14, fontWeight: 'bold' }}
                                    color="text.primary"
                                    gutterBottom>
                                    Can I edit the evaluation form?
                                </Typography>
                                <Typography variant="body2">
                                    The form cannot be edited once it has been
                                    submitted.
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                        lineHeight: '20px',
                                    }}
                                    color="text.primary"
                                    gutterBottom>
                                    Can I submit an accompanying letter?
                                </Typography>
                                <Typography variant="body2">
                                    No, TAMU CVM and TTU SVM do not accept
                                    letters of evaluation, only the Veterinary
                                    Evaluation Form.
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                    <div
                        style={{
                            padding: '5px',
                        }}>
                        <Typography
                            sx={{
                                fontWeight: 'bold',
                                fontSize: 18,
                            }}>
                            HELP!
                        </Typography>
                        <Typography>Need help completing the</Typography>
                        <Typography>evaluation? Give us a ring!</Typography>
                        <Typography
                            sx={{
                                fontWeight: 'bold',
                                fontSize: 18,
                            }}>
                            (512) 499-4785
                        </Typography>
                        <a href="mailto: Letmein@tmdsas.com">
                            Letmein@tmdsas.com
                        </a>
                    </div>
                </div>
            </Box>
        </>
    )
}
export default Dashboard
